import { render } from "./CartIcon.vue?vue&type=template&id=1b1a38d0&scoped=true&bindings={}"
import script from "./CartIcon.vue?vue&type=script&lang=ts"
export * from "./CartIcon.vue?vue&type=script&lang=ts"

import "./CartIcon.vue?vue&type=style&index=0&id=1b1a38d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b1a38d0"

export default script